<template>
  <section id="dashboard-ecommerce">
    <b-card no-body>
      <b-card-header>
        <b-card-title class="mb-1">
          Monitoring Inventarisasi BMD
        </b-card-title>
      </b-card-header>
      <div class="m-2">
        <b-col
          cols="8"
          offset-md="2"
          class="mb-1"
        >
          <h4>Filter</h4>
          <b-form
            class="needs-validation"
            @submit.prevent="submitFilter"
          >
            <b-row>
              <b-col
                cols="10"
                offset-md="1"
              >
                <b-form-group
                  label="Tahun Pelaksanaan"
                  label-for="tahunFilter"
                >
                  <b-form-select
                    id="tahunFilter"
                    v-model="tahunFilter"
                    :options="dataTahunPelaksanaan"
                    disabled
                  />
                </b-form-group>
                <b-form-group
                  label="Wilayah"
                  label-for="wilayahFilter"
                >
                  <b-form-select
                    id="wilayahFilter"
                    v-model="wilayahFilter"
                    :options="dataWilayah"
                    @change="changeWilayah"
                  />
                </b-form-group>
                <b-form-group
                  label="PD/UPD"
                  label-for="pdUpdFilter"
                >
                  <v-select
                    id="kolok"
                    v-model="pdUpdFilterValue"
                    label="text"
                    :options="dataPdUpd"
                    :disabled="
                      !$can('Filter', 'monitoring') &&
                        !$can('Filter-PdUpd', 'monitoring')
                    "
                    @search="searchPdUpd"
                    @input="inputPdUpd"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-col
              cols="11"
              align="right"
              class="pr-0"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                type="submit"
              >
                Filter
              </b-button>
            </b-col>
          </b-form>
        </b-col>
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Entri</label>
            <v-select
              v-model="perPageSummary"
              dir="ltr"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
              @input="inputPerPageSummary"
            />
            <div class="align-self-center">
              <b-dropdown
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                right
                variant="primary"
                text="Print Excel"
                size="sm"
                dropup
              >
                <b-dropdown-item @click="clickPrintXl">
                  Monitoring
                </b-dropdown-item>
                <b-dropdown-item @click="clickPrintSemuaBaris">
                  Semua Input
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-col
                cols="9"
                md="7"
              >
                <b-form-input
                  v-model="searchQueryDashboardSummary"
                  class="d-inline-block mr-1"
                  placeholder="Tekan Enter"
                  @keyup.enter="keyUpSearchDashboardSummary"
                />
              </b-col>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-overlay
        :show="isShowTableSummary"
        variant="light"
        opacity="0.85"
        blur="2px"
        rounded="sm"
      >
        <b-table
          ref="refInvoiceListTable"
          :items="rowsDashboardSummary"
          responsive
          :fields="tableColumnsDashboardSummary"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
          class="position-relative"
          small
        >
          <template #cell(collapse)="row">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="btn-icon"
              size="sm"
              @click="clickCollapse(row)"
            >
              <feather-icon :icon="row.detailsShowing ? 'ChevronDownIcon' : 'ChevronRightIcon'" />
            </b-button>
          </template>

          <template #row-details="row">
            <b-card>
              <b-table
                responsive
                :items="row.item.details"
                :fields="columnBmd"
                striped
                bordered
                hover
                small
              >
                <!-- Column: status -->
                <template #cell(status)="data">
                  <b-badge
                    v-if="
                      data.item.status == 1 ||
                        data.item.status == 2 ||
                        data.item.status == 3
                    "
                    variant="light-secondary"
                  >
                    Belum Inventarisasi
                  </b-badge>
                  <b-badge
                    v-else-if="data.item.status == 4"
                    variant="light-success"
                  >
                    Melakukan Input Pada Web
                  </b-badge>
                  <b-badge
                    v-else-if="data.item.status == 5"
                    variant="light-info"
                  >
                    Menunggu Validasi Data Informasi
                  </b-badge>
                  <b-badge
                    v-else-if="data.item.status == 6"
                    variant="light-danger"
                  >
                    Dikembalikan Validasi Data Informasi
                  </b-badge>
                  <b-badge
                    v-else-if="data.item.status == 7"
                    variant="light-secondary"
                  >
                    Belum Cetak QR
                  </b-badge>
                  <b-badge
                    v-else-if="data.item.status == 8"
                    variant="light-primary"
                  >
                    Belum Scan QR dan Foto
                  </b-badge>
                  <b-badge
                    v-else-if="data.item.status == 9"
                    variant="light-success"
                  >
                    Selesai Inventarisasi
                  </b-badge>
                </template>
              </b-table>
            </b-card>
          </template>

          <!-- Column: jumlahBelumSensus -->
          <template #cell(jumlahBelumSensus)="data">
            {{
              data.item.jumlahBmdKolok
                ? numThousand(data.item.jumlahBelumSensus)
                : "-"
            }}
          </template>

          <!-- Column: jumlahSedangSensus -->
          <template #cell(jumlahSedangSensus)="data">
            {{
              data.item.jumlahBmdKolok
                ? numThousand(data.item.jumlahSedangSensus)
                : "-"
            }}
          </template>

          <!-- Column: jumlahSelesaiSensus -->
          <template #cell(jumlahSelesaiSensus)="data">
            {{
              data.item.jumlahBmdKolok
                ? numThousand(data.item.jumlahSelesaiSensus)
                : "-"
            }}
          </template>

          <!-- Column: persentase -->
          <template #cell(persentase)="data">
            <b-badge :variant="`light-${data.item.jumlahBmdKolok ? (data.item.jumlahSelesaiSensus / data.item.jumlahBmdKolok) * 100 <= 33 ? 'danger' : (data.item.jumlahSelesaiSensus / data.item.jumlahBmdKolok) * 100 > 33 && (data.item.jumlahSelesaiSensus / data.item.jumlahBmdKolok) * 100 < 66 ? 'warning' : 'success' : 'secondary'}`">
              {{
                (data.item.jumlahBmdKolok
                  ? (data.item.jumlahSelesaiSensus / data.item.jumlahBmdKolok) *
                    100
                    ? (
                      (data.item.jumlahSelesaiSensus /
                        data.item.jumlahBmdKolok) *
                      100
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\./g, ",")
                    : 0
                  : "-") + "%"
              }}
            </b-badge>
          </template>

          <!-- Column: jumlahBmdKolok -->
          <template #cell(jumlahBmdKolok)="data">
            {{
              data.item.jumlahBmdKolok
                ? numThousand(data.item.jumlahBmdKolok)
                : "-"
            }}
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Menampilkan
                {{ (currentPageSummary - 1) * perPageSummary + 1 }} hingga
                {{ currentPageSummary * perPageSummary }} dari
                {{ totalRecordsDashboardSummary }} entri</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPageSummary"
                :total-rows="totalRecordsDashboardSummary"
                :per-page="perPageSummary"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="changePageSummary"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BButton,
  BForm,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import dashboard from '@/composables/dashboard'
import master from '@/composables/master'
import cetakDaftarBmd from '@/composables/cetakDaftarBmd'
import { generateYears, startYear, intThousand } from '@/libs/helper'
import apiTelegram from '@/composables/telegram/sendData'

const { showError } = require('@/libs/helper')

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')
    const isLoadingChart = ref(false)
    const isPrint = ref(false)

    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: '' })
    const wilayahFilter = ref($route.query.wilayah || '')
    const tahunFilter = ref($route.query.tahun || year)
    const dataPie = ref([])
    const dataCapaianInventarisasi = ref([])
    const isShowTable = ref(true)
    const isShowTableSummary = ref(true)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') { wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10) }

    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const statusFilter = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const rows = ref([])

    const perPageSummary = ref(10)
    const totalRecordsDashboardSummary = ref(0)
    const searchQueryDashboardSummary = ref('')
    const rowsDashboardSummary = ref([])
    const currentPageSummary = ref(1)

    const pieChart = ref(null)

    const dataStatus = ref([{ value: '', text: '-- Semua --' }])

    const dataWilayah = ref([])
    const dataPdUpd = ref([{ text: '-- Semua --', value: '' }])
    const tempListYear = generateYears(startYear, year)
    tempListYear.unshift({
      text: '--Semua--',
      value: '',
    })
    const dataTahunPelaksanaan = ref(tempListYear)

    const tableColumnsDashboardSummary = [
      { key: 'collapse', label: '' },
      { key: 'kolokSkpd', label: 'kolok skpd' },
      { key: 'nalokSkpd', label: 'nalok skpd' },
      { key: 'kolok' },
      { key: 'nalok' },
      { key: 'wilayah', label: 'Wilayah' },
      { key: 'jumlahBmdKolok', label: 'Jml Total BMD' },
      { key: 'jumlahBelumSensus', label: 'Jumlah Belum Inventarisasi' },
      {
        key: 'belumValidasiKeberadaan',
        label: 'Jumlah Belum Validasi Keberadaan',
      },
      {
        key: 'keberadaanDikembalikan',
        label: 'Jumlah Dikembalikan Keberadaan',
      },
      {
        key: 'melakukanInputPadaWeb',
        label: 'Jumlah Melakukan Input Pada Web',
      },
      {
        key: 'belumValidasiDataInformasi',
        label: 'Jumlah Belum Validasi Data Informasi',
      },
      {
        key: 'dikembalikanValidasiDataInformasi',
        label: 'Jumlah Dikembalikan Data Informasi',
      },
      { key: 'belumCetakQR', label: 'Jumlah Belum Cetak QR' },
      { key: 'belumScanQRdanFoto', label: 'Jumlah Belum Scan QR dan Foto' },
      { key: 'jumlahSelesaiSensus', label: 'Jumlah Selesai Inventarisasi' },
      { key: 'persentase', label: 'Persentase' },
    ]

    const columnBmd = ref([
      {
        key: 'guid_aset',
        label: 'Guid ID',
      },
      {
        key: 'kolok',
        label: 'Kolok',
      },
      {
        key: 'nalok',
        label: 'Nalok',
      },
      {
        key: 'kobar_108',
        label: 'Kobar',
      },
      {
        key: 'nabar_108',
        label: 'Nabar',
      },
      {
        key: 'HARGA',
        label: 'Harga',
      },
      {
        key: 'ALAMAT',
        label: 'Alamat',
      },
      {
        key: 'UKU_SAT',
        label: 'Ukuran',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'TGLOLEH',
        label: 'Tanggal Oleh',
      },
    ])

    const dataSummary = async () => {
      isShowTableSummary.value = true

      const params = {
        filter_ukpd: pdUpdFilter.value,
        length: perPageSummary.value,
        start: (currentPageSummary.value - 1) * perPageSummary.value,
        search: searchQueryDashboardSummary.value,
        kode_wilayah: wilayahFilter.value,
      }
      const dashboardSummary = await dashboard.getDashboardSummary(g, params)
      const { code, list, totalList } = dashboardSummary

      if (code == 200) {
        rowsDashboardSummary.value = list
        totalRecordsDashboardSummary.value = totalList
      } else {
        rowsDashboardSummary.value = []
        totalRecordsDashboardSummary.value = 0
      }

      isShowTableSummary.value = false
    }

    const submitFilter = () => {
      const url = `?wilayah=${wilayahFilter.value}&tahun=${tahunFilter.value}&pd-upd=${pdUpdFilter.value}`
      window.history.pushState('', '', url)
      dataSummary()
    }

    const getStatus = async () => {
      let tempStatus = [{ text: '-- Semua --', value: '' }]
      let resStatus = await master.getStatus(g)
      tempStatus = [...tempStatus, ...resStatus.data]

      const params = {
        list: 'unfound',
      }
      resStatus = await master.getStatus(g, params)
      tempStatus = [...tempStatus, ...resStatus.data]

      dataStatus.value = tempStatus
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Semua --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    const keyUpSearchDashboardSummary = () => {
      currentPageSummary.value = 1
      dataSummary()
    }

    const inputPerPageSummary = () => {
      dataSummary()
    }

    const changePageSummary = () => {
      dataSummary()
    }

    const searchPdUpd = async search => {
      getPdUpd(search)
    }

    const changeWilayah = () => {
      if (cookiesJenisAkun.value != 'D' && cookiesJenisAkun.value != 'F') {
        pdUpdFilterValue.value = { text: '-- Semua --', value: '' }
        pdUpdFilter.value = ''
      }
      getPdUpd()
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) { pdUpdFilter.value = pdUpdFilterValue.value.value }
    }

    const clickCollapse = async item => {
      if (!rowsDashboardSummary.value[item.index].details) {
        const params = {
          // filter_kib: kibFilter.value,
          filter_tahun: tahunFilter.value,
          filter_upd: item.item.kolok,
          // filter_keberadaan: keberadaanFilter.value,
          kode_wilayah: wilayahFilter.value,
          // filter_status: statusFilter.value,
          length: 100000000,
          start: 0,
          // cari: searchTerm.value,
          username: g.$cookies.get('username'),
        }
        const resBmd = await cetakDaftarBmd.getBmd(g, params)
        const { code, list } = resBmd

        rowsDashboardSummary.value[item.index].details = code == 200 ? list : []
      }

      item.toggleDetails()
    }

    const clickPrintXl = async () => {
      try {
        isPrint.value = true

        window.open(
          `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/list-summary?filter_kib=C&filter_upd=${pdUpdFilter.value}&kd_wilayah=${wilayahFilter.value}&length=1000000`,
          '_blank',
        )
      } catch (error) {
        console.log(error)
        showError(g, { request: error.toString() }, 'Gagal Print Excel')
      }

      isPrint.value = false
    }

    const clickPrintSemuaBaris = async () => {
      try {
        isPrint.value = true

        apiTelegram.sendMessage(g, {
          text: JSON.stringify({
            sourceSystem: 'inventarisasiPengguna',
            action: 'monitoringPrintSemuaInput',
            pesan: {
              pdupd: pdUpdFilter.value,
              username: g.$cookies.get('username'),
            },
            idUser: g.$cookies.get('username'),
          }),
        })

        window.open(
          `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/laporan/export-all-record?filter_kib=C&filter_upd=${pdUpdFilter.value}`,
          '_blank',
        )
      } catch (error) {
        console.log(error)
        showError(g, { request: error.toString() }, 'Gagal Print Excel')
      }

      isPrint.value = false
    }

    const numThousand = value => intThousand(value)

    dataSummary()
    getWilayah()
    getStatus()
    getPdUpd()

    return {
      isPrint,
      perPage,
      perPageSummary,
      perPageOptions,
      searchQuery,
      searchQueryDashboardSummary,
      dataStatus,
      columnBmd,
      statusFilter,
      rows,
      rowsDashboardSummary,
      tableColumnsDashboardSummary,
      sortBy,
      isSortDirDesc,
      totalRecords,
      totalRecordsDashboardSummary,
      currentPage,
      currentPageSummary,
      isLoadingChart,
      isShowTable,
      isShowTableSummary,
      pdUpdFilterValue,
      pdUpdFilter,
      wilayahFilter,
      tahunFilter,
      dataWilayah,
      dataTahunPelaksanaan,
      dataPdUpd,
      dataPie,
      dataCapaianInventarisasi,
      changeWilayah,
      searchPdUpd,
      inputPdUpd,
      submitFilter,
      keyUpSearchDashboardSummary,
      changePageSummary,
      inputPerPageSummary,
      clickCollapse,
      pieChart,
      numThousand,
      clickPrintXl,
      clickPrintSemuaBaris,
    }
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BButton,
    BForm,
    BFormGroup,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
